import $ from "jquery";

class ColumnScroll {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.titles = self.elem.querySelectorAll('[data-column-scroll-title]');
        self.items = self.elem.querySelectorAll('[data-column-scroll-item]');
        self.container = self.elem.querySelector('[data-column-scroll-container]');
    }

    init() {
        let self = this;

        self.scroll();

        window.onresize = function(event) {
            self.scroll();
        };
    }

    scroll() {
        let self = this;

        self.container.addEventListener('scroll', (e) => {
            self.items.forEach(function (item) {
                if (self.isScrolledIntoView(item) == true) {
                    self.titles.forEach(function (title) {
                        if (title.dataset.columnScrollTitleCount === item.dataset.columnScrollItemCount) {
                            title.classList.add('is-active');
                        } else {
                            title.classList.remove('is-active');
                        }
                    });
                }
            });
        });
    }

    isScrolledIntoView(elem) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();

        var elemTop = $(elem).offset().top;
        var elemBottom = elemTop + $(elem).height();

        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }
}

export default ColumnScroll;
